export const cacheInit = (cache: any) => {
  cache.writeData({
    data: {
      advertisersPageCache: {
        from: 0,
        size: 25,
        sortOptions: {
          name: 'ASC',
          tgrams_id: 'DESC',
          thomasCampaigns: 'DESC'
        },
        activeSort: {
          sortKey: 'name',
          sortDirection: 'ASC'
        },
        searchTerm: '',
        preSearchTerm: ''
      },
      advertisersByPointsPageCache: {
        from: 0,
        size: 25,
        sortOptions: {
          name: 'ASC',
          tgrams_id: 'DESC',
          campaigns: 'DESC'
        },
        activeSort: {
          sortKey: 'name',
          sortDirection: 'ASC'
        },
        searchTerm: '',
        preSearchTerm: ''
      },
      fulfillmentAuditPageCache: {
        sortOptions: {
          advertiser_name: 'ASC',
          campaign_name: 'DESC',
          quantity: 'DESC',
          tgrams_id: 'DESC',
          allocatedPoints: 'DESC',
          opportunity_id: 'DESC',
          item_id: 'DESC',
          status: 'DESC',
          owner: 'DESC',
          valid: 'DESC'
        },
        activeSort: {
          sortKey: 'advertiser_name',
          sortDirection: 'ASC'
        },
        searchTerm: '',
        preSearchTerm: ''
      },
      advertisersByPVSPageCache: {
        from: 0,
        size: 25,
        sortOptions: {
          name: 'ASC',
          tgrams_id: 'DESC',
          campaigns: 'DESC'
        },
        activeSort: {
          sortKey: 'name',
          sortDirection: 'ASC'
        },
        searchTerm: '',
        preSearchTerm: ''
      },
      productFulfillmentListCache: {
        from: 0,
        size: 20
      },
      configurationsPageCache: {
        tabOptions: ['Associated Configurations', 'Configuration Templates'],
        activeTab: 'Associated Configurations',
        Assigned: [],
        Unassigned: []
      },
      campaignModule: null
    }
  });
};
